import React from "react";
import { Tick, MailboxInstallImg } from "../../../../../assets";
import { MdInfo } from "react-icons/md";
import { MailBoxFeatures } from "../constants";

const IntegrationBenefits = ({ addEmailBox, setAddEmailBox }) => {
  return (
    <section className="max-w-xl">
      <img
        src={MailboxInstallImg}
        alt="MailChimp Installation Guide"
        className="my-4"
      />
      <p className="text-sm text-gray-500 my-2.5">
        Connect your mailbox to manage all messages from your customers in your
        CausalFunnel Inbox!
      </p>
      <button
        className="text-white mt-3 bg-indigo-600 py-1.5 rounded-md px-3.5 hover:bg-indigo-500 hover:cursor-pointer"
        onClick={() => {
          setAddEmailBox(true);
        }}
      >
        Connect your mailbox
      </button>
      <div>
        <h3 className="text-xl font-semibold py-3 border-bottom my-3">
          Integration benefits
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-3">
          {MailBoxFeatures.map((item, index) => (
            <FeatureItem {...item} key={index} />
          ))}
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3">
        <a
          href="https://www.causalfunnel.com/blog"
          target="_blank"
          rel="noreferrer noopener"
          className="text-indigo-600 hover:underline flex items-center pb-3 gap-1.5 border-bottom"
        >
          <MdInfo className="text-2xl" />
          <p>How it Works</p>
        </a>
        <p className="text-sm">
          By connecting your mailbox with Tidio, you receive all your email
          messages in Tidio inbox. It means you can handle your communication
          more efficiently without the risk of losing the context. Your data is
          safe and secure - no third-party apps have access to it.
        </p>
      </div>
    </section>
  );
};

export default IntegrationBenefits;

const FeatureItem = ({ content }) => {
  return (
    <div className="flex gap-2">
      <div className="">
        <Tick className="text-green-600" />
      </div>
      <div>
        <h3 className="text-[14px]">{content}</h3>
      </div>
    </div>
  );
};
